import React, { useState, useEffect } from 'react';
import NavItem from './NavItem';
import { LinkItems } from '../utils/constants';
import { useUserContext } from '../context/user_context';
import logo from '../assets/daristaGoldLogoPM.png';
import "./nav.css"
import {
  Box,
  CloseButton,
  Flex,
  useColorModeValue,
  // Image,
} from '@chakra-ui/react';

export default function SidebarContent({ onClose, ...rest }) {
  const {
    currentUser: { privilege },
  } = useUserContext();
  const [links, setLinks] = useState([]);

  useEffect(() => {
    const filteredLinks = getLinksByPrivilege(privilege);
    setLinks(filteredLinks);
  }, [privilege]);

  const getLinksByPrivilege = (privilege) => {
    if (privilege === 'super') {
      // Super: Can see Home, Products, Orders, Users (not Clients)
      return LinkItems.filter((link) => link.name !== 'Clients');
    }
    if (privilege === 'moderate') {
      // Moderate: Can see Home, Products, Orders (not Users, not Clients)
      return LinkItems.filter((link) => link.name !== 'Users' && link.name !== 'Clients');
    }
    if (privilege === 'low') {
      // Low: Can only see Home, Orders (not Users, not Products, not Clients)
      return LinkItems.filter(
        (link) => link.name !== 'Users' && link.name !== 'Products' && link.name !== 'Clients'
      );
    }
    return [];
  };
    
  

  return (
    <Box
      transition='3s ease'
      bg={useColorModeValue('white', 'gray.900')}
      borderRight='1px'
      borderRightColor={useColorModeValue('gray.200', 'gray.700')}
      w={{ base: 'full', md: 60 }}
      pos='fixed'
      h='full'
      {...rest}
    >
      <Flex h='20' alignItems='center' mx='8' justifyContent='space-between'>
        {/* <Image src={logo} /> */}
        <img  className='image' src={logo} alt='' />
        <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} />
      </Flex>
      {links.map((link) => (
        <NavItem key={link.name} icon={link.icon} url={link.url}>
          {link.name}
        </NavItem>
      ))}
    </Box>
  );
}
